import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatEvent, ChatInput } from './chat.types';

/**
 * @experimental
 * Generic, provider-agnostic chat transport. Each implementation (ai-assistants SSE,
 * storybook fake, Vibe adapter) translates its provider's wire format into/out of the
 * lib-owned `ChatEvent`/`ChatInput` vocabulary and owns its own request-context construction.
 */
export interface ChatTransport {
  readonly events$: Observable<ChatEvent>;
  send(input: ChatInput): void;
}

/**
 * @experimental
 * DI seam for `ChatTransport`. Hosts provide an implementation per chat surface
 * (e.g. `{ provide: CHAT_TRANSPORT, useClass: FakeChatTransport }`).
 */
export const CHAT_TRANSPORT = new InjectionToken<ChatTransport>('[AiChat]: chat transport');
